export default {
  DARK: {
    heading: p => p.accentWhite,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    icons: p => p.primaryLight,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.tertiaryDark,
    icons: p => p.primaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.tertiaryDark,
    icons: p => p.primaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
